import * as ngCore from '@angular/core'

import * as state from '../../../../../../../../../state'

import * as complete from './complete'
import * as incomplete from './incomplete'

/**
 * Allows the user to complete a deployment evaluation and view its results
 */
@ngCore.Component({
  imports: [complete.Component, incomplete.Component],
  selector: 'atn-quiver-deployment-modal-evaluation-step',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.quiver.evaluation.Feature} */
  public readonly evaluationFeature = ngCore.inject(
    state.quiver.evaluation.Feature,
  )
}
